import { Suspense, FC, StrictMode } from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { AxiosInterceptor } from 'mir-utils/axios';
import { Loading } from 'mir-utils/components';
import { FeedbackProvider, TimeProvider, LocaleProvider } from 'mir-utils/providers';
import './mir-utils/i18n';
import { TitlePage } from 'router/TitlePage';
import { ThemeProvider } from 'mir-utils/theme/ThemeProvider';
import { SupportChatProvider } from 'help-desk-eddy/SupportChatProvider';
import { App } from './App';
// Шрифт Roboto не загружается MUI автоматически.
// https://mui.com/material-ui/react-typography/#install-with-npm
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const WholeApp: FC = () => {
  return (
    <StrictMode>
      <Suspense fallback={<Loading />}>
        <BrowserRouter>
          <LocaleProvider>
            <ThemeProvider>
              <TitlePage />
              <FeedbackProvider>
                <TimeProvider>
                  <CssBaseline />
                  <AxiosInterceptor />
                  <SupportChatProvider>
                    <App />
                  </SupportChatProvider>
                </TimeProvider>
              </FeedbackProvider>
            </ThemeProvider>
          </LocaleProvider>
        </BrowserRouter>
      </Suspense>
    </StrictMode>
  );
};

render(<WholeApp />, document.getElementById('root'));
